<script lang="ts">
  import type { PageData } from './$types';
  import type { CourseModel } from '@24hbs/utils';
  import { customPageOptions } from '$lib/utils/layout-store';
  import type { IListingPage, ISeoMetadataFields } from '$lib/utils/contentful/types';
  import { GtmStore } from '$lib/utils/gtm-store';
  import { error } from '@sveltejs/kit';
  import { StructureUtils } from '$lib/utils/structured-utils';
  import { PUBLIC_BASE_URL } from '$env/static/public';
  import { browser } from '$app/environment';
  import Head from '$lib/components/atoms/Head/Head.svelte';
  import { TemplateWithImage } from '$lib/components/organisms/Listing/Templates';
	import TemplateWithoutImage from '$lib/components/organisms/Listing/Templates/TemplateWithoutImage.svelte';
  
  export let data: PageData;
  
  const listingPage: IListingPage = data.listingPageData;
  
  if (!listingPage || !listingPage.fields.template) {
    error(404);
  }

  const highlightedItems: CourseModel[] = data.highlightedItems;
  
  const courses: CourseModel[] = data.courses.courses || [];
  const totalCourses: number = Number(data.courses.total);
  
  let listingPageFilters;
  $: listingPageFilters = data.listingPageFilters;
  
  customPageOptions({ headerFixed: true, bodyStyle: 'gray' });
  
  /******************** GTM EVENT PUSH *************************/
  GtmStore.pushEvent({
    pageCategory: listingPage.fields.title
  });
  /*************************************************************/
  
  let seoDetails = {
    title: listingPage.fields.template.fields.heroTitle,
    description: listingPage.fields.template.fields.heroDescription,
    image: ''
  };
  
  if (listingPage.fields.template.fields.heroImage) {
    seoDetails.image = listingPage.fields.template.fields.heroImage.fields.file.url;
  }
  
  const seoMetadata: ISeoMetadataFields | null = listingPage.fields.seoMetadata?.fields || null;
  
  if (seoMetadata) {
    if (seoMetadata.seoTitle) {
      seoDetails.title = seoMetadata.seoTitle;
    }
    if (seoMetadata.seoDescription) {
      seoDetails.description = seoMetadata.seoDescription;
    }
    if (seoMetadata.noindex) {
      seoDetails.noindex = seoMetadata.noindex;
    }
    if (seoMetadata.nofollow) {
      seoDetails.nofollow = seoMetadata.nofollow;
    }
  }
  
  const breadcrumbJson = StructureUtils.getBreadcrumbStructure([
      {
        name: 'Home',
        url: PUBLIC_BASE_URL,
      },
      {
        name: listingPage.fields.title,
        url: `${PUBLIC_BASE_URL}/${listingPage.fields.slug}`,
      },
    ],
    true
  );
  const courseListJson = StructureUtils.getCourseListStructure(courses, true);
  
  if (!browser) {
    seoDetails.ldScriptTag = StructureUtils.createScriptTag(
    JSON.stringify([breadcrumbJson, courseListJson])
  );
  }
</script>

<Head appendCompany {seoDetails} />

{#if listingPage && typeof listingPage !== 'undefined' && listingPage.fields && listingPage.fields.template}
  {#if listingPage.fields.template.sys.contentType.sys.id === 'ListingPageTemplateWithImage'}
    <TemplateWithImage
      {listingPage}
      {listingPageFilters}
      {courses}
      {totalCourses}
      {highlightedItems}
    />
  {/if}
  {#if listingPage.fields.template.sys.contentType.sys.id === 'ListingPageTemplateWithoutImage'}
    <TemplateWithoutImage
      {listingPage}
      {listingPageFilters}
      {courses}
      {totalCourses}
      {highlightedItems}
    />
  {/if}
{/if}